export default {
  "[表情_1]": "https://jiangyinghui.cn/emoji/1.png",
  "[表情_2]": "https://jiangyinghui.cn/emoji/2.png",
  "[表情_3]": "https://jiangyinghui.cn/emoji/3.png",
  "[表情_4]": "https://jiangyinghui.cn/emoji/4.png",
  "[表情_5]": "https://jiangyinghui.cn/emoji/5.png",
  "[表情_6]": "https://jiangyinghui.cn/emoji/6.png",
  "[表情_7]": "https://jiangyinghui.cn/emoji/7.png",
  "[表情_8]": "https://jiangyinghui.cn/emoji/8.png",
  "[表情_9]": "https://jiangyinghui.cn/emoji/9.png",
  "[表情_10]": "https://jiangyinghui.cn/emoji/10.png",
  "[表情_11]": "https://jiangyinghui.cn/emoji/11.png",
  "[表情_12]": "https://jiangyinghui.cn/emoji/12.png",
  "[表情_13]": "https://jiangyinghui.cn/emoji/13.png",
  "[表情_14]": "https://jiangyinghui.cn/emoji/14.png",
  "[表情_15]": "https://jiangyinghui.cn/emoji/15.png",
  "[表情_16]": "https://jiangyinghui.cn/emoji/16.png",
  "[表情_17]": "https://jiangyinghui.cn/emoji/17.png",
  "[表情_18]": "https://jiangyinghui.cn/emoji/18.png",
  "[表情_19]": "https://jiangyinghui.cn/emoji/19.png",
  "[表情_20]": "https://jiangyinghui.cn/emoji/20.png",
  "[表情_21]": "https://jiangyinghui.cn/emoji/21.png",
  "[表情_22]": "https://jiangyinghui.cn/emoji/22.png",
  "[表情_23]": "https://jiangyinghui.cn/emoji/23.png",
  "[表情_24]": "https://jiangyinghui.cn/emoji/24.png",
  "[表情_25]": "https://jiangyinghui.cn/emoji/25.png",
  "[表情_26]": "https://jiangyinghui.cn/emoji/26.png",
  "[表情_27]": "https://jiangyinghui.cn/emoji/27.png",
  "[表情_28]": "https://jiangyinghui.cn/emoji/28.png",
  "[表情_29]": "https://jiangyinghui.cn/emoji/29.png",
  "[表情_30]": "https://jiangyinghui.cn/emoji/30.png",
  "[表情_31]": "https://jiangyinghui.cn/emoji/31.png",
  "[表情_32]": "https://jiangyinghui.cn/emoji/32.png",
  "[表情_33]": "https://jiangyinghui.cn/emoji/33.png",
  "[表情_34]": "https://jiangyinghui.cn/emoji/34.png",
  "[表情_35]": "https://jiangyinghui.cn/emoji/35.png",
  "[表情_36]": "https://jiangyinghui.cn/emoji/36.png",
  "[表情_37]": "https://jiangyinghui.cn/emoji/37.png",
  "[表情_38]": "https://jiangyinghui.cn/emoji/38.png",
  "[表情_39]": "https://jiangyinghui.cn/emoji/39.png",
  "[表情_40]": "https://jiangyinghui.cn/emoji/40.png",
  "[表情_41]": "https://jiangyinghui.cn/emoji/41.png",
  "[表情_42]": "https://jiangyinghui.cn/emoji/42.png",
  "[表情_43]": "https://jiangyinghui.cn/emoji/43.png",
  "[表情_44]": "https://jiangyinghui.cn/emoji/44.png",
  "[表情_45]": "https://jiangyinghui.cn/emoji/45.png",
  "[表情_46]": "https://jiangyinghui.cn/emoji/46.png",
  "[表情_47]": "https://jiangyinghui.cn/emoji/47.png",
  "[表情_48]": "https://jiangyinghui.cn/emoji/48.png",
  "[表情_49]": "https://jiangyinghui.cn/emoji/49.png",
  "[表情_50]": "https://jiangyinghui.cn/emoji/50.png",
  "[表情_51]": "https://jiangyinghui.cn/emoji/51.png",
  "[表情_52]": "https://jiangyinghui.cn/emoji/52.png",
  "[表情_53]": "https://jiangyinghui.cn/emoji/53.png",
  "[表情_54]": "https://jiangyinghui.cn/emoji/54.png",
  "[表情_55]": "https://jiangyinghui.cn/emoji/55.png",
  "[表情_56]": "https://jiangyinghui.cn/emoji/56.png",
  "[表情_57]": "https://jiangyinghui.cn/emoji/57.png",
  "[表情_58]": "https://jiangyinghui.cn/emoji/58.png",
  "[表情_59]": "https://jiangyinghui.cn/emoji/59.png",
  "[表情_60]": "https://jiangyinghui.cn/emoji/60.png",
  "[表情_61]": "https://jiangyinghui.cn/emoji/61.png",
  "[表情_62]": "https://jiangyinghui.cn/emoji/62.png",
  "[表情_63]": "https://jiangyinghui.cn/emoji/63.png",
  "[表情_64]": "https://jiangyinghui.cn/emoji/64.png",
  "[表情_65]": "https://jiangyinghui.cn/emoji/65.png",
  "[表情_66]": "https://jiangyinghui.cn/emoji/66.png",
  "[表情_67]": "https://jiangyinghui.cn/emoji/67.png",
  "[表情_68]": "https://jiangyinghui.cn/emoji/68.png",
  "[表情_69]": "https://jiangyinghui.cn/emoji/69.png",
  "[表情_70]": "https://jiangyinghui.cn/emoji/70.png",
  "[表情_71]": "https://jiangyinghui.cn/emoji/71.png",
  "[表情_72]": "https://jiangyinghui.cn/emoji/72.png",
  "[表情_73]": "https://jiangyinghui.cn/emoji/73.png",
  "[表情_74]": "https://jiangyinghui.cn/emoji/74.png",
  "[表情_75]": "https://jiangyinghui.cn/emoji/75.png",
  "[表情_76]": "https://jiangyinghui.cn/emoji/76.png",
  "[表情_77]": "https://jiangyinghui.cn/emoji/77.png",
  "[表情_78]": "https://jiangyinghui.cn/emoji/78.png",
  "[表情_79]": "https://jiangyinghui.cn/emoji/79.png",
  "[表情_80]": "https://jiangyinghui.cn/emoji/80.png",
  "[表情_81]": "https://jiangyinghui.cn/emoji/81.png",
  "[表情_82]": "https://jiangyinghui.cn/emoji/82.png",
  "[表情_83]": "https://jiangyinghui.cn/emoji/83.png",
  "[表情_84]": "https://jiangyinghui.cn/emoji/84.png",
  "[表情_85]": "https://jiangyinghui.cn/emoji/85.png",
  "[表情_86]": "https://jiangyinghui.cn/emoji/86.png",
  "[表情_87]": "https://jiangyinghui.cn/emoji/87.png",
  "[表情_88]": "https://jiangyinghui.cn/emoji/88.png",
  "[表情_89]": "https://jiangyinghui.cn/emoji/89.png",
  "[表情_90]": "https://jiangyinghui.cn/emoji/90.png",
  "[表情_91]": "https://jiangyinghui.cn/emoji/91.png",
  "[表情_92]": "https://jiangyinghui.cn/emoji/92.png",
  "[表情_93]": "https://jiangyinghui.cn/emoji/93.png",
  "[表情_94]": "https://jiangyinghui.cn/emoji/94.png",
  "[表情_95]": "https://jiangyinghui.cn/emoji/95.png",
  "[表情_96]": "https://jiangyinghui.cn/emoji/96.png",
  "[表情_97]": "https://jiangyinghui.cn/emoji/97.png",
  "[表情_98]": "https://jiangyinghui.cn/emoji/98.png",
  "[表情_99]": "https://jiangyinghui.cn/emoji/99.png",
  "[表情_100]": "https://jiangyinghui.cn/emoji/100.png",
  "[表情_101]": "https://jiangyinghui.cn/emoji/101.png",
  "[表情_102]": "https://jiangyinghui.cn/emoji/102.png",
  "[表情_103]": "https://jiangyinghui.cn/emoji/103.png",
  "[表情_104]": "https://jiangyinghui.cn/emoji/104.png",
  "[表情_105]": "https://jiangyinghui.cn/emoji/105.png",
  "[表情_106]": "https://jiangyinghui.cn/emoji/106.png",
  "[表情_107]": "https://jiangyinghui.cn/emoji/107.png",
  "[表情_108]": "https://jiangyinghui.cn/emoji/108.png",
  "[表情_109]": "https://jiangyinghui.cn/emoji/109.png",
  "[表情_110]": "https://jiangyinghui.cn/emoji/110.png",
  "[表情_111]": "https://jiangyinghui.cn/emoji/111.png",
  "[表情_112]": "https://jiangyinghui.cn/emoji/112.png",
  "[表情_113]": "https://jiangyinghui.cn/emoji/113.png",
  "[表情_114]": "https://jiangyinghui.cn/emoji/114.png",
  "[表情_115]": "https://jiangyinghui.cn/emoji/115.png"
};
